import { compose } from "redux";
import { connect } from "react-redux";
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ClearIcon from "@material-ui/icons/Clear";
import Fab from '@material-ui/core/Fab';
import Grid from '@material-ui/core/Grid';
import Modal from '@material-ui/core/Modal';
import ClassModel from '@material-ui/core/Modal';
import PropTypes from 'prop-types';
import React from 'react';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { addProgram, fetchPrograms, updateProgram } from "../actions/ProgramAction";
import { addClass, fetchClass } from "../actions/ClassAction";
import { fetchUsers } from "../actions/UserAction"
import moment from "moment";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { Link } from 'react-router-dom'
import Badge from '@material-ui/core/Badge';

const CustomTableCell = withStyles(theme => ({
    head: {
        color: "#2926ac",
        fontWeight: "bold",
        fontSize: 13
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
        // borderBottom: '5px solid black',
    };
}

const styles = theme => ({
    root: {
        float: 'right',
    },
    paper: {
        position: 'absolute',
        width: innerWidth >= 480 ? theme.spacing.unit * 100 : (innerWidth - (theme.spacing.unit * 2)),
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: innerWidth >= 480 ? theme.spacing.unit * 4 : theme.spacing.unit * 2,
        outline: 'none',
        borderRadius: 5,
        maxHeight: innerHeight - (theme.spacing.unit * 2),
        // borderBottom: '5px solid red'
    },
    margin: {
        margin: theme.spacing.unit,
    },
    closeButtonFab: {
        float: 'right',
        marginRight: innerWidth >= 480 ? '-54px' : '-34px',
        marginTop: innerWidth >= 480 ? '-54px' : '-44px'  
    },
    gradientButton: {
        background: '#2cc676',
        color: '#fff',
        float: 'right',
        '&:focus': {
            background: '#27ad67'
        },
        '&:hover': {
            background: '#27ad67'
        },
        '&:active': {
            background: '#27ad67'
        }
    },

    gradientWarningButton: {        
        background: '#ffc107',
        color: '#fff',
        margin: theme.spacing.unit,
        '&:focus': {
            background: '#d39e00'
        },
        '&:hover': {
            background: '#d39e00'
        },
        '&:active': {
            background: '#d39e00'
        }
    },

    backGrd: {
        background: 'linear-gradient(to right, #2926ac 0%, #6128be 100%)',
        height: 20
    },
    cancelbutton: {
        margin: theme.spacing.unit,
    },

    updatebutton: {
        background: 'linear-gradient(to right, green 0%, #6128be 100%)',
        margin: theme.spacing.unit,
        height: 30,

        color: 'white',
        textAlign: "center"
    },
    addButton: {
        background: 'linear-gradient(to right, #2926ac 0%, #6128be 100%)',
        color: 'green',
    },
    button: {
        background: 'linear-gradient(to right, #2926ac 0%, #6128be 100%)',
        color: 'white'
    },
    textField: {
        width: 350,
        
        marginTop: -8,
        marginLeft: 8
    },
    textField1: {
        width: 350,
        height:200,
        marginTop: -8,
        marginLeft: 8
    },
    inputStyle: {
        padding: '12px 1px',
        fontSize: 12,
        color: 'rgba(0, 0, 0, 0.87)'
    },
    labelRoot: {
        fontSize: '1.3rem'
    },
    formControl: {
        margin: theme.spacing.unit,
        width: 350,
        marginTop: 0,
        marginLeft: 8
    },
    formControl1: {
        margin: theme.spacing.unit,
        width: 350,
        marginTop: 21,
        marginLeft: 8
    },
});
const { innerWidth, innerHeight } = window;
class Program extends React.Component {
    constructor() {
        super();
        this.state = {
            mode: null,
            open: false,
            program_name: null,
            description: null,
            program_id: null,
            program_name_error: false,
            editProgram: {},
            classModelOpen: false,
            take_by: null,
            class_name: '',
            class_description: null,
            library_id: null,
            bookable_id: null,
            start_time: '',
            end_time: '',
            day_of_week: '',
            date: '',
            // description: '',
            library_id_error: false,
            bookable_id_error: false,
            start_time_error: false,
            end_time_error: false,
            class_name_error: false,
            day_of_week_error: false,
            date_error: false,
            take_by_error: false,
            libraries: [],
            bookings: [],
            library: null,
            booking: null,
            booked_time: []

        };
    }

    static getDerivedStateFromProps(props, state) {
        if (state.libraries !== props.libraries) {
            return {
                libraries: props.libraries,
            }
        }
        return null;
    }

    componentDidMount() {
        this.props.dispatch(fetchPrograms())
        this.props.dispatch(fetchUsers())
        this.props.dispatch(fetchClass())
    }

    handleOpen = (param, program) => {
        this.setState({ open: true, mode: param, editProgram: program })
        if (param === "edit") {
            this.setState({ program_name: program.program_name, description: program.description })
        }
    };

    handleClose = () => {
        this.setState({
            open: false,
            program_name: null,
            description: null,
            program_name_error: false,
            classModelOpen: false
        });
    };

    submitForm = () => {
        let isError = false;
        if (this.state.program_name === null) {
            this.setState({ program_name: "" })
            this.setState({ program_name_error: true })
            isError = true
        }
        if (this.state.description === null) {
            this.setState({ description: "" })
            isError = true
        }
        if (isError === false) {
            let program = {}
            if (this.state.mode === "edit") {
                program.user_id = this.state.editProgram.user_id
                program.status = this.state.editProgram.status
                program.id = this.state.editProgram.id
            }
            program.program_name = this.state.program_name
            program.description = this.state.description
            console.log(JSON.stringify(program))
            this.state.mode === "add" ? this.props.dispatch(addProgram(this, program)) : this.props.dispatch(updateProgram(program, this.state.editProgram.id))
            this.setState({
                open: false,
                program_name: null,
                description: null,
            })
        }
    }

    classFormSubmit = () => {
        let start_time = new Date(this.state.date + " " + this.state.start_time)
        let end_time = new Date(this.state.date + " " + this.state.end_time)

        // this.setState({ start_time : moment(start_time). format(), end_time : moment(end_time). format()})
        let isError = false;

        if (this.state.library_id === null) {
            this.setState({ library_id_error: true })
            isError = true
        }
        if (this.state.take_by === null) {
            this.setState({ take_by_error: true })
            isError = true
        }

        if (this.state.date === "") {
            this.setState({ date_error: true })
            isError = true
        }

        if (this.state.start_time === "") {
            this.setState({ start_time_error: true })
            isError = true
        }
        if (this.state.end_time === "") {
            this.setState({ end_time_error: true })
            isError = true
        }
        if (this.state.class_name === "") {
            this.setState({ class_name_error: true })
            isError = true
        }
        if (isError === false) {
            let classValues = {}
            let booking = {}
            booking.start_time = moment(start_time).format()
            booking.end_time = moment(end_time).format()
            booking.library_id = this.state.library_id
            booking.bookable_id = this.state.bookable_id
            booking.day_of_week = this.state.day_of_week
            booking.date = this.state.date
            booking.booking_for = 'class'
            booking.description = this.state.description
            classValues.program_id = this.state.program_id
            classValues.class_name = this.state.class_name
            classValues.taken_by = this.state.take_by
            classValues.description = this.state.class_description
            classValues.status = "Active"
            this.props.dispatch(addClass(this, booking, classValues, this.state.program_id))
            // console.log("************************classValues*********8", classValues)
            this.setState({
                classModelOpen: false,
                library_id: null,
                take_by: null,
                start_time: '',
                end_time: '',
                day_of_week: '',
                date: '',
                description: '',
                program_id: "",
                library_id_error: false,
                bookable_id_error: false,
                start_time_error: false,
                end_time_error: false,
                day_of_week_error: false,
                date_error: false,
                class_name: '',
                class_name_error: false,
                // take_by: null,
                class_description: ''

            })
        }
    }

    dateChange = event => {
        let day_of_week = moment(event.target.value).format("dddd")
        this.setState({ date: event.target.value, day_of_week: day_of_week })
        let booked_times = (this.props.bookedTimes.length > 0 ? this.props.bookedTimes.filter(time => moment(time.date).format('MMDDYYYY') === moment(event.target.value).format('MMDDYYYY')) : [])
        this.setState({ booked_time: booked_times })
    }
    timeChange = event => {
        this.setState({ start_time: event.target.value })
    }



    returnClassCount(prgId) {
        var classLengthValues = 0
        if (this.props.classObject.length > 0) {
            classLengthValues = this.props.classObject.filter((filterClass) => filterClass.program_id === prgId).length
        }
        return classLengthValues
    }

    render() {

        const { classes } = this.props;
        return (
            <div >
                <Grid container spacing={8}>
                    <Grid item xs={12} >
                        <Button variant="contained" color="secondary" size="small" className={classes.gradientButton} onClick={() => { this.handleOpen("add", {}) }}> Add Program</Button>
                    </Grid>
                </Grid>
                
                <div style={{ marginTop: 50 , overflowX: "Auto"}}>
                    {this.props.programs.length > 0 ?
                        <Table className={classes.table}>
                            <TableHead>
                                <TableRow>
                                    <CustomTableCell>Name</CustomTableCell>
                                    <CustomTableCell align="left">Description</CustomTableCell>
                                    <CustomTableCell align="center">Actions</CustomTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.props.programs.map(program =>
                                    <TableRow className={classes.row} >
                                        <CustomTableCell align="left">{program.program_name}</CustomTableCell>
                                        <CustomTableCell align="left">{program.description}</CustomTableCell>
                                        <CustomTableCell align="center">
                                            <Button onClick={() => { this.handleOpen("edit", program) }} size="small" className={classes.gradientWarningButton} >
                                                Update
                                             </Button>

                                            <Button variant="contained" size="small" color="primary" component={Link} to={`/classView/${program.id}`}>
                                                {this.returnClassCount(program.id) > 0 ? <Badge color="secondary" badgeContent={this.returnClassCount(program.id)}>View Class</Badge> : "View Class"}
                                            </Button>


                                            {/* <Button onClick={() => this.setState({ classModelOpen: true,program_id:program.id })} variant="contained" color="secondary" size="small" className={classes.cancelbutton} >
                                                
                                             </Button> */}
                                        </CustomTableCell>
                                    </TableRow>)}

                            </TableBody>
                        </Table>
                        : null}
                </div>
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.state.open}
                    onClose={this.handleClose}
                    disableBackdropClick={true}
                >
                    <div style={getModalStyle()} className={classes.paper}>
                        <div className={classes.closeButtonFab}>
                            <Fab size="small" color="secondary" aria-label="Add" className={classes.margin} onClick={this.handleClose}>
                                <ClearIcon />
                            </Fab>
                        </div>
                        <Typography variant="h6" style={{ marginBottom: 20 }} >
                            {this.state.mode === "add" ? "Add Program" : "Edit Program"}
                        </Typography>
                        <Grid container spacing={8}>
                            <Grid item xs={innerWidth > 480 ? 6 : 6} >
                                <TextField
                                    id="standard-name"
                                    label="Name"
                                    // style={{ marginTop: 8 }}
                                    fullWidth
                                    required
                                    error={this.state.program_name_error === true ? true : false}
                                    helperText={this.state.program_name_error === true ? "Please Enter Program Name" : false}
                                    // className={classes.textField}
                                    value={this.state.program_name || ""}
                                    onChange={(event) => this.setState({ program_name: event.target.value, })}
                                    // margin="normal"
                                    InputProps={{ classes: { input: classes.inputStyle } }}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={innerWidth > 480 ? 6 : 6} >
                                <TextField
                                    id="standard-name"
                                    label="Description"
                                    // style={{ marginTop: 8 }}
                                    fullWidth                         
                                    // className={classes.textField}
                                    value={this.state.description || ""}
                                    onChange={(event) => this.setState({ description: event.target.value, })}
                                    // margin="normal"
                                    InputProps={{ classes: { input: classes.inputStyle } }}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} >
                                <div style={{ textAlign: "center" }}>
                                    <Button onClick={this.handleClose} variant="contained" color="secondary" size="small" className={classes.cancelbutton}>
                                        cancel
                                    </Button>
                                    <Button onClick={() => { this.submitForm() }} variant="contained" size="small" className={classes.button}>
                                        Submit
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </Modal>
                <ClassModel
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.state.classModelOpen}
                    onClose={this.handleClose}
                    disableBackdropClick={true}
                >
                    <div style={getModalStyle()} className={classes.paper}>
                        <div className={classes.closeButtonFab}>
                            <Fab size="small" color="secondary" aria-label="Add" className={classes.margin} onClick={this.handleClose}>
                                <ClearIcon />
                            </Fab>
                        </div>
                        <Typography variant="h6" style={{ marginBottom: 20 }} >
                            Add Class
                        </Typography>
                        <Grid container spacing={8}>
                            <Grid item xs={6} >
                                <form>
                                    <FormControl className={classes.formControl}>
                                        <InputLabel required shrink htmlFor="library_name" error={this.state.library_id_error === true ? true : false} >Library Name</InputLabel>
                                        <Select
                                            required
                                            error={this.state.library_id_error === true ? true : false}
                                            value={this.state.library_id || ""}
                                            onChange={(event) => this.setState({ library_id: event.target.value })}
                                            inputProps={{
                                                name: 'Library Name',
                                                id: 'library_name',
                                            }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        >

                                            {this.state.libraries.length > 0 && this.state.libraries.map(library => (
                                                <MenuItem key={library.id} value={library.id}>{library.library_name}</MenuItem>
                                            ))}

                                            {
                                                this.state.libraries.length === 0 &&
                                                <MenuItem key={0} value={0}>{`Select Library`}</MenuItem>
                                            }

                                        </Select>
                                        <FormHelperText error> {this.state.library_id_error === true ? "Please Select Library" : false} </FormHelperText>
                                    </FormControl>
                                </form>
                            </Grid>
                            <Grid item xs={6} >
                                <TextField
                                    id="standard-name"
                                    label=" Date"
                                    type="date"
                                    fullWidth
                                    className={classes.textField}
                                    required
                                    error={this.state.date_error === true ? true : false}
                                    helperText={this.state.date_error === true ? "Please Enter Date" : false}
                                    value={this.state.date || ""}
                                    onChange={this.dateChange}
                                    // onChange={(event) => this.setState({ date: event.target.value, date_error: false })}
                                    margin="normal"
                                    InputProps={{ classes: { input: classes.inputStyle } }}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                />
                            </Grid>
                            {this.state.booked_time.length > 0 ?
                                <Grid item xs={12}>
                                    <Typography>Today booked time slots are </Typography>
                                    <Typography>Start Time: {this.state.booked_time.map(time => <Typography>{moment(time.start_time).format('LT')} </Typography>)} </Typography>
                                    <Typography>End Time: {this.state.booked_time.map(time => <Typography>{moment(time.end_time).format('LT')} </Typography>)} </Typography>
                                </Grid> : null}
                            <Grid item xs={6} >
                                <TextField
                                    id="time"
                                    label="Start Time"
                                    type="time"
                                    fullWidth
                                    required
                                    className={classes.textField}
                                    value={this.state.start_time}
                                    onChange={this.timeChange}
                                    // onChange={(event) => this.setState({ start_time: event.target.value, start_time_error: false })} 
                                    helperText={this.state.start_time_error === true ? "Please start time" : false}
                                    error={this.state.start_time_error === true ? true : false}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    inputProps={{
                                        step: 300, // 5 min
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6} >
                                <TextField
                                    id="time"
                                    label="End Time"
                                    type="time"
                                    fullWidth
                                    required
                                    className={classes.textField}
                                    value={this.state.end_time}
                                    onChange={(event) => this.setState({ end_time: event.target.value, end_time_error: false })}
                                    helperText={this.state.end_time_error === true ? "Please end time" : false}
                                    error={this.state.end_time_error === true ? true : false}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    inputProps={{
                                        step: 300,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6} >
                                <TextField
                                    id="standard-name"
                                    label="Description"
                                    style={{ marginTop: 8 }}
                                    fullWidth
                                    className={classes.textField}
                                    value={this.state.description || ""}
                                    onChange={(event) => this.setState({ description: event.target.value, })}
                                    margin="normal"
                                    InputProps={{ classes: { input: classes.inputStyle } }}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6} >
                                <TextField
                                    id="standard-name"
                                    label="Class Name"
                                    style={{ marginTop: 8 }}
                                    fullWidth
                                    required
                                    error={this.state.class_name_error === true ? true : false}
                                    helperText={this.state.class_name_error === true ? "Please Enter Class Name" : false}
                                    className={classes.textField}
                                    value={this.state.class_name || ""}
                                    onChange={(event) => this.setState({ class_name: event.target.value, })}
                                    margin="normal"
                                    InputProps={{ classes: { input: classes.inputStyle } }}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6} >
                                <TextField
                                    id="standard-name"
                                    label="Class Description"
                                    style={{ marginTop: 8 }}
                                    fullWidth
                                    className={classes.textField}
                                    value={this.state.class_description || ""}
                                    onChange={(event) => this.setState({ class_description: event.target.value, })}
                                    margin="normal"
                                    InputProps={{ classes: { input: classes.inputStyle } }}
                                    InputLabelProps={{
                                        shrink: true,
                                        FormLabelClasses: {
                                            root: classes.labelRoot
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6} >
                                <form>
                                    <FormControl className={classes.formControl1}>
                                        <InputLabel required shrink htmlFor="Coach Name" error={this.state.take_by_error === true ? true : false} >Class Taken</InputLabel>
                                        <Select
                                            required
                                            error={this.state.take_by_error === true ? true : false}
                                            value={this.state.take_by || ""}
                                            onChange={(event) => this.setState({ take_by: event.target.value })}
                                            inputProps={{
                                                name: 'Coach Name',
                                                id: 'coach_name',
                                            }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        >

                                            {this.props.users.length > 0 && this.props.users.filter((user) => user.user_type === 'COACH').map(u => (
                                                <MenuItem key={u.id} value={u.id}>{u.first_name}</MenuItem>
                                            ))}

                                            {
                                                this.props.users.length === 0 &&
                                                <MenuItem key={0} value={0}>{`Select Coach`}</MenuItem>
                                            }

                                        </Select>
                                        <FormHelperText error> {this.state.take_by_error === true ? "Please Select Coach Name" : false} </FormHelperText>
                                    </FormControl>
                                </form>
                            </Grid>
                            <Grid item xs={12} >
                                <div style={{ textAlign: "center" }}>
                                    <Button onClick={this.handleClose} variant="contained" color="secondary" size="small" className={classes.cancelbutton}>
                                        cancel
                                    </Button>
                                    <Button onClick={this.classFormSubmit} variant="contained" size="small" className={classes.button}>
                                        Submit
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </ClassModel>
            </div>
        );
    }
}

Program.propTypes = {
    classes: PropTypes.object.isRequired,

};

const mapStateToProps = (state) => {
    return {
        programs: state.ProgramReducer.programs,
        user: state.SessionReducer.user,
        bookedTimes: state.BookedReducer.bookedTimes,
        libraries: state.LibraryReducer.myLibrary,
        myTeam: state.TeamReducer.myTeam,
        users: state.UserReducer.users,
        classObject: state.ClassReducer.classesValue
    }
}


export default compose(withStyles(styles), connect(mapStateToProps))(Program);